import { hasProfile } from 'app/shared/utils';

export const ADMIN_HAS_EPROJET_ACCESS_KEY = 'adminHasEProjetAccess_localstorage';

const PROJECT_ROLES = ['Partenaire ACEP Projets', 'Mandataire Projets', 'Mandataire administratif Projets'];

/**
 * Accès Espace Projet de l'interface affichée.
 * Superviseur / Admin E. Partenaire : accès du contexte choisi sur la page de sélection.
 * Autres utilisateurs : rôle Projets (synchronisé avec Company.HasEProjetAccess).
 */
export function hasEspaceProjetAccess(user: any): boolean {
  if (hasProfile(user, ['Superviseur'])) {
    return localStorage.getItem('supervisorHasEProjetAccess_localstorage') === 'true';
  }
  if (hasProfile(user, ['Admin E. Partenaire'])) {
    return localStorage.getItem(ADMIN_HAS_EPROJET_ACCESS_KEY) !== 'false';
  }
  return hasProfile(user, PROJECT_ROLES);
}
